(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(route)
    .controller('InterventionsCheckup', InterventionsCheckup);

    route.$inject = ['$routeProvider'];
    function route ($routeProvider) {
        $routeProvider.when('/interventions/checkup', {
            templateUrl: 'partials/openbase/checkup.html',
            controller: 'InterventionsCheckup',
            reloadOnSearch: false
        });
    }

    function InterventionsCheckup ($scope, swif) {
        'ngInject';
        $scope.debug = {};
        $scope.link_map = {
            'task': '/interventions/tasks'
        };
        $scope.fields_map = {
            'intervention_request': ['name', 'create_date', 'write_date'],
            'task': ['name', 'project_id', 'recurrence_id', 'user_id', 'team_id', 'partner_id', 'effective_hours', 'state'],
            'work': ['name', 'date', 'hours', 'task_id', 'user_id', 'team_id', 'partner_id']
        };
        $scope.toggleShowMore = toggleShowMore;
        $scope.showDebug = showDebug;
        $scope.fix = fix;

        $scope.checkup = [
            {
                title: 'Demande d\'interventions sans demandeur',
                params: {
                    domain: [['partner_id', '=', false], ['partner_address', '=', false], ['people_email', '=', false]],
                    fields: $scope.fields_map.intervention_request
                },
                content_type: 'intervention_request'
            },
            {
                title: 'Demande d\'interventions assigne à un service non assignable',
                params: {
                    domain: [['service_id.is_assignable_to_ask', '=', false], ['state', 'in', ['valid', 'finished']]],
                    fields: $scope.fields_map.intervention_request
                },
                category: 'warning',
                content_type: 'intervention_request'
            },
            {
                title: 'Demande d\'interventions validée sans catégorie',
                params: {
                    domain: [['intervention_assignement_id', '=', false], ['state', 'in', ['valid', 'finished']]],
                    fields: $scope.fields_map.intervention_request
                },
                content_type: 'intervention_request'
            },
            {
                title: 'Interventions assigne à un service non assignable',
                params: {
                    domain: [['service_id.is_assignable_to_project', '=', false]],
                    fields: $scope.fields_map.intervention_request
                },
                content_type: 'intervention'
            },
            {
                title: 'Interventions sans catégories',
                params: {
                    domain: [['intervention_assignement_id', '=', false]],
                    fields: $scope.fields_map.intervention_request
                },
                content_type: 'intervention'
            },
            {
                title: 'TACHES planifiée non assignée',
                params: {
                    domain: [['state', '=', 'open'], ['user_id', '=', false], ['team_id', '=', false], ['partner_id', '=', false]],
                    fields: $scope.fields_map.task
                },
                content_type: 'task'
            },
            {
                title: 'TACHES sans catégories',
                params: {
                    domain: [['category_id', '=', false]],
                    fields: $scope.fields_map.task
                },
                content_type: 'task'
            },
            {
                title: 'TACHES relevées sans heures passées',
                params: {
                    domain: [['work_ids', '!=', false], '|', ['effective_hours', '=', 0.0], ['effective_hours', '=', false]],
                    fields: $scope.fields_map.task
                },
                content_type: 'task'
            },
            {
                title: 'RELEVES TACHES sans heures',
                params: {
                    domain: ['|', ['hours', '=', 0.0], ['hours', '=', false]],
                    fields: $scope.fields_map.work
                },
                content_type: 'work'
            },
            {
                title: 'RELEVES TACHES sans couts',
                params: {
                    domain: ['|', ['cost', '=', 0.0], ['cost', '=', false]],
                    fields: $scope.fields_map.work
                },
                category: 'warning',
                content_type: 'work'
            },
            {
                title: 'RELEVES TACHES sans couts avec agent sans cout horaire',
                params: {
                    domain: ['|', ['cost', '=', 0.0], ['cost', '=', false], '|', ['user_id.cost', '=', 0.0], ['user_id.cost', '=', false]],
                    fields: $scope.fields_map.work
                },
                category: 'warning',
                content_type: 'work'
            },
            {
                title: 'RELEVES TACHES sans couts mais avec agent ayant cout horaire',
                params: {
                    domain: ['|', ['unit_cost', '=', 0.0], ['unit_cost', '=', false], ['user_id.cost', '>', 0.0]],
                    fields: $scope.fields_map.work
                },
                content_type: 'work'
            },
            {
                title: 'RELEVES TACHES sans couts mais assigne a un prestataire',
                params: {
                    domain: ['|', ['cost', '=', 0.0], ['cost', '=', false], ['partner_id', '!=', false]],
                    fields: $scope.fields_map.work
                },
                content_type: 'work'
            },
            {
                title: 'RELEVES TACHES avec equipe sans agent',
                params: {
                    domain: [['team_id', '!=', false], ['user_id', '=', false]],
                    fields: $scope.fields_map.work
                },
                content_type: 'work'
            },
            {
                title: 'RELEVES TACHES sans intervenant (agent, equipe, prestataire)',
                params: {
                    domain: [
                        ['user_id', '=', false],
                        ['team_id', '=', false],
                        ['partner_id', '=', false]
                    ],
                    fields: $scope.fields_map.work
                },
                content_type: 'work'
            },
            //CONFIGURATION
            {
                title: 'Organisation(s) sans service (technical_service_id)',
                params: {domain: [['technical_service_id', '=', false], ['is_department', '=', false]]},
                category: 'warning',
                content_type: 'partner',
                edit: $scope.link_map.partner
            },
            {
                title: 'Aucune de catégorie d\'intervention',
                params: {},
                error_on_empty: true,
                content_type: 'intervention_category',
                edit: $scope.link_map.partner
            },
            {
                title: 'Aucune de catégorie de tâche',
                params: {},
                error_on_empty: true,
                content_type: 'task_category',
                edit: $scope.link_map.partner
            },
            {
                title: 'Aucune de catégorie d\'absence',
                params: {},
                error_on_empty: true,
                content_type: 'absence_category',
                edit: $scope.link_map.partner
            }
            /*{
                title: 'Utilisateur(s) sans tz',
                params: {domain: [['context_tz', '=', false]]},
                content_type: 'user',
                edit: $scope.link_map.partner,
                fix: function () {
                    return {context_tz:'Europe/Paris'};
                }
            }*/
        ];

        function setError (check) {
            if (check.category === 'warning') {
                check.warning = true;
            } else {
                check.error = true;
            }
        }
        _.forEach($scope.checkup, function (check) {
            var params = check.params;
            if(!params.fields) {
                params.fields = ['id', 'name'];
            }
            swif.data.get(check.content_type, undefined, check.params)
            .then(function (results) {
                check.results = results;
                if (results.length === 0) {
                    if (check.error_on_empty) {
                        setError(check);
                    } else {
                        check.success = true;
                    }
                } else {
                    if (check.error_on_empty) {
                        check.success = true;
                    } else {
                        setError(check);
                    }
                }
            });
        });

        /*var addCheckTaskAgentNotInService = function () {
            var domain = [['user_id', '!=', false], ['team_id', '!=', false], ['state', '!=', 'done']];
            var fields = ['name', 'service_id', 'user_id', 'team_id'];
            var data = [];
            var ret = {
                title: 'TACHES EN COURS: agent / equipe n\'appartenant pas au service de la TACHE (inconsisitence)',
                content_type: 'task'
            };
            $q.all(
                swif.data.get('task', undefined, {domain: domain, fields: fields}),
                swif.data.get('user', undefined, {fields: ['name', 'service_ids']})
            ).then(function (tasks, users) {
                _.forEach(results, function (tasks) {

                });
                ret.results = data;
            });
            $scope.checkup.push(ret);
        };*/

        // addCheckTaskAgentNotInService();


        function toggleShowMore (check) {
            check.more = !check.more;
        }
        function showDebug (item) {
            $scope.debug[item.id] = !$scope.debug[item.id];
        }
        function fix(check, item) {
            if (check.fix && item) {
                var data = check.fix(item);
                swif.data.save(check.content_type, item.id, data);
            }
        }
    }

})();
